import { render, staticRenderFns } from "./EmailBroadcast.vue?vue&type=template&id=cb484252&scoped=true&"
import script from "./EmailBroadcast.vue?vue&type=script&lang=js&"
export * from "./EmailBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./EmailBroadcast.vue?vue&type=style&index=0&id=cb484252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb484252",
  null
  
)

export default component.exports